import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3i6pw6vu4j: FaireBrandEntity = {
  token: "b_3i6pw6vu4j",
  type: "brand",
  name: "Tiny Treats and ZOMI GEMS",
  avatarUrl:
    "https://cdn.faire.com/fastly/389df5097384fba77e5423b88aefd30e77a6be0d97c03c81e196b94123fdd4fa.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/abe75ede0d53cafdd0fa5f3d8fb0902d2bbdee153ade4bb768f7f411cb615f5e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/389df5097384fba77e5423b88aefd30e77a6be0d97c03c81e196b94123fdd4fa.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/abe75ede0d53cafdd0fa5f3d8fb0902d2bbdee153ade4bb768f7f411cb615f5e.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 226,
  isTopShop: true,
  isInsider: true,
  description:
    "Tiny Treats and ZOMI GEMS - fashion jewelry and accessories for kids. The inspiration behind the brand is my two daughters. They love to wear all kinds of accessories and they inspired me to create a brand that has a wide variety of accessories. Tiny Treats offers handbags, sunglasses and hair accessories for kids of all ages.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:12.955Z",
    importedBy: "entity-db-cli",
  },
};
